import * as documentVerificationApi from './api';
import { showError } from 'actions/actionCreators/snackbarActions';
import { sendHttpRequest, sendHttpCommandAndWaitForEvent } from 'actions/actionCreators/httpActions';
import * as types from './actionTypes';
import * as eventTypes from './eventTypes';

export function loadDocumentVerifications(documentId, siteId) {
  return async (dispatch, getState) => {
    const key = `${documentId}-${siteId}`;
    let loading = false,
      loaded = false;
    const flags = getState().document.verifications[key];
    if (flags) {
      loading = flags.loading;
      loaded = flags.loaded;
    }

    if (loading || loaded) return;

    try {
      dispatch({ type: types.LOAD_DOCUMENT_VERIFICATIONS_STARTED, id: key });
      const documentVerifications = await dispatch(sendHttpRequest(documentVerificationApi.getDocumentVerifications(documentId, siteId)));
      dispatch({ type: types.LOAD_DOCUMENT_VERIFICATIONS_SUCCEEDED, payload: documentVerifications, id: key });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function generateManualVerifications(verificationsToLaunch) {
  return async dispatch => {
    dispatch({ type: types.MANUAL_VERIFICATIONS_LAUNCH_STARTED });

    try {
      let event = await dispatch(
        sendHttpCommandAndWaitForEvent(
          documentVerificationApi.generateManualVerifications(verificationsToLaunch),
          'GenerateManualVerifications',
          [eventTypes.MANUAL_VERIFICATIONS_TASKS_GENERATED],
          true
        )
      );

      if (event.ok) dispatch({ type: types.MANUAL_VERIFICATIONS_LAUNCH_SUCCEEDED });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      dispatch({ type: types.MANUAL_VERIFICATIONS_LAUNCH_FAILED });
    }
  };
}

export function loadDocumentEntities(documentId, siteId) {
  return async (dispatch, getState) => {
    const key = `${documentId}-${siteId}`;
    let documentEntities = getState().document.entities[key];
    if (documentEntities?.isLoaded || documentEntities?.loading) return documentEntities;

    try {
      dispatch({ type: types.LOAD_DOCUMENT_ENTITIES_STARTED, payload: { key } });
      documentEntities = await dispatch(sendHttpRequest(documentVerificationApi.getDocumentEntities(documentId, siteId)));

      dispatch({ type: types.LOAD_DOCUMENT_ENTITIES_SUCCEEDED, payload: { documentEntities, key } });
    } catch (error) {
      dispatch({ type: types.LOAD_DOCUMENT_ENTITIES_FAILED, payload: error });
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}
